import { render } from "./duration.vue?vue&type=template&id=5f5302d5&ts=true"
import script from "./duration.ts?vue&type=script&lang=ts&external"
export * from "./duration.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__